import { useAuth } from '@/auth/AuthProvider';
import { Button, Card, CardBody, CardHeader, CardTitle, Input, Label } from '@/components/ui';
import { PageHeader } from '@/components/domain';

/**
 * Min profil.
 *
 * Siden viser og gemmer ingenting laengere - og det er ikke en mangel, men resultatet af to
 * beslutninger. Navn og rolle ejes andre steder (Microsoft-kontoen og en administrator), og
 * notifikationskanalen findes ikke: alt gaar paa Teams. Der er derfor hverken en Gem-knap
 * eller en formular; et felt man kan skrive i uden at det bliver gemt, er vaerre end et felt
 * der er tydeligt laast.
 */
export function ProfilePage() {
  const { user } = useAuth();

  return (
    <>
      <PageHeader title="Min profil" description={user?.email} />

      <div className="grid gap-4 lg:grid-cols-2">
        <Card>
          <CardHeader>
            <CardTitle>Oplysninger</CardTitle>
          </CardHeader>
          <CardBody className="space-y-4">
            <div>
              <Label htmlFor="name">Navn</Label>
              <Input id="name" value={user?.name ?? ''} disabled />
              <p className="mt-1 text-xs text-ink-muted">
                Navnet kommer fra din Microsoft-konto og deles med de øvrige OneCode-systemer. Skal
                det rettes, skal en administrator gøre det.
              </p>
            </div>

            <div>
              <Label htmlFor="role">Rolle</Label>
              <Input id="role" value={user?.role_label ?? ''} disabled />
              <p className="mt-1 text-xs text-ink-muted">
                Kun en administrator kan ændre din rolle.
              </p>
            </div>

            <div>
              <Label htmlFor="notifications">Notifikationer</Label>
              <Input id="notifications" value="Teams" disabled />
              <p className="mt-1 text-xs text-ink-muted">
                Alarmer leveres i Codepass-kanalen i Teams. Der er ikke noget at vælge — og
                ingenting at slå fra: en kritisk alarm om manglende fakturering skal ses af hele
                teamet, ikke kun af dem der har notifikationer slået til.
              </p>
            </div>
          </CardBody>
        </Card>

        {/*
          Ingen "skift adgangskode" her. Login gaar gennem Microsoft, og adgangskoden hoerer
          til Microsoft-kontoen - ikke til Codepass. En knap her ville enten fejle eller
          saette en adgangskode der ikke bruges til noget, og begge dele er vaerre end at
          lade vaere.
        */}
        <Card>
          <CardHeader>
            <CardTitle>Sikkerhed</CardTitle>
          </CardHeader>
          <CardBody className="space-y-3">
            <p className="text-sm text-ink-muted">
              Du logger ind med din Microsoft-konto. Adgangskode, to-faktor og andre
              sikkerhedsindstillinger styres derfor hos Microsoft — ikke i Codepass.
            </p>
            <a
              href="https://myaccount.microsoft.com/security-info"
              target="_blank"
              rel="noreferrer"
              className="inline-block"
            >
              <Button variant="secondary">Åbn Microsoft-kontoindstillinger</Button>
            </a>
          </CardBody>
        </Card>
      </div>
    </>
  );
}
